var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "auto",
      "overflow-x": "hidden"
    }
  }, [_c('div', {
    staticClass: "logo-con",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "20px"
    },
    style: ({
      background: _vm.menuTheme !== 'dark' ? '#497ff7' : ''
    })
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebar),
      expression: "!sidebar"
    }],
    on: {
      "click": _vm.herfchange
    }
  }, [_c('img', {
    staticClass: "maxlogo",
    attrs: {
      "src": require("../../assets/logo.png")
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sidebar),
      expression: "sidebar"
    }],
    on: {
      "click": _vm.herfchange
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo-mini.png")
    }
  })])]), _vm._v(" "), (!_vm.sidebar) ? _c('Menu', {
    ref: "sideMenu",
    staticStyle: {
      "background": "#497ff7"
    },
    attrs: {
      "active-name": _vm.$route.path,
      "theme": _vm.menuTheme,
      "open-names": _vm.openedSubmenuArr,
      "width": "auto"
    },
    on: {
      "on-select": _vm.changeMenu
    }
  }, [_vm._l((_vm.permission_routers), function(item) {
    return (!item.hidden && item.children.length > 0 && item.path.split('/')[1] === _vm.menu) ? [_vm._l((item.children), function(child) {
      return [_c('MenuItem', {
        key: child.name,
        staticStyle: {
          "color": "#ffffff",
          "position": "relative",
          "overflow": "hidden",
          "padding": "26px 0"
        },
        attrs: {
          "name": item.path + '/' + child.path
        }
      }, [_c('svg-icon', {
        staticStyle: {
          "margin-right": "6px",
          "font-size": "30px",
          "position": "absolute",
          "left": "16px",
          "top": "50%",
          "transform": "translate(0,-50%)"
        },
        attrs: {
          "icon-class": child.icon
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "layout-text",
        staticStyle: {
          "font-size": "16px",
          "position": "absolute",
          "left": "48px",
          "top": "54%",
          "transform": "translate(0,-50%)"
        }
      }, [_vm._v(_vm._s(child.title))])], 1)]
    })] : _vm._e()
  })], 2) : (_vm.sidebar) ? _c('div', {
    staticClass: "shrink"
  }, [_vm._l((_vm.permission_routers), function(item, index) {
    return (!item.hidden && item.children.length > 0 && item.path.split('/')[1] === _vm.menu) ? [(item.children.length !== 0) ? _c('Dropdown', {
      key: index,
      attrs: {
        "transfer": "",
        "placement": "right-start"
      },
      on: {
        "on-click": _vm.changeMenu
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((item.children), function(child, i) {
      return [(item.children.length !== 0) ? _c('Dropdown', {
        key: index,
        attrs: {
          "transfer": "",
          "placement": "right-start"
        },
        on: {
          "on-click": _vm.changeMenu
        }
      }, [_c('router-link', {
        staticStyle: {
          "display": "inline-block",
          "height": "100%",
          "width": "100%"
        },
        attrs: {
          "tag": "span",
          "to": item.path + '/' + child.path
        }
      }, [_c('Button', {
        staticClass: "shrinkbutton",
        attrs: {
          "type": "text"
        }
      }, [_c('svg-icon', {
        staticStyle: {
          "font-size": "34px",
          "color": "#FFFFFF"
        },
        attrs: {
          "icon-class": child.icon
        }
      })], 1)], 1), _vm._v(" "), _c('DropdownMenu', {
        staticClass: "shrinkdropdownMenu",
        attrs: {
          "slot": "list"
        },
        slot: "list"
      }, [_c('DropdownItem', {
        key: i,
        attrs: {
          "name": item.path + '/' + child.path
        }
      }, [_c('svg-icon', {
        staticStyle: {
          "color": "#495060",
          "font-size": "16px"
        },
        attrs: {
          "icon-class": child.icon
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "dropdownItemIcon",
        staticStyle: {
          "color": "#495060",
          "font-size": "14px"
        }
      }, [_vm._v(_vm._s(child.title))])], 1)], 1)], 1) : _vm._e()]
    })] : _vm._e()
  })], 2) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dea58b0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar.vue
// module id = YA1U
// module chunks = 166